export enum TIPO_CONSULTA {

    CONSULTA_CON_FILTRO = "01",
    CONSULTA_SELECTOR = "02",
    CONSULTA_SELECTOR_CON_PARAMETRO = "03"
}



// WEBPACK FOOTER //
// ./src/co/sura/dominio/sat/config_servicios/modelo/TipoConsulta.ts